/** @module Debug/CustomView/RequestGenerator/ClassViewSelector */
define([
    "dojo/_base/declare",
    "csi/reflection"
], function(declare,reflection) {

    return declare(null,{
        /**
         * String[]: Names of classes to process. Process all classes if it's null or empty
         */
        classNames: null,

        /**
         * Set<String>: Set of Ids of Views to include globally. Process all views if it's null or empty
         */
        specificViewIds: null,

        /**
         * Set<String>: Set of Ids of Views to exclude globally
         */
        ignoringViewIds: null,

        /**
         * Map<reflection.Class, Set<String>>: the map between reflection classes and view Ids to include for processing
         */
        classToViewIdMap: null,

        constructor: function() {
            this.classToViewIdMap = new Map();
        },

        /**
         * Use only the specified classes for processing
         *
         * @param {string[]} classNames
         */
        setClassNames: function(classNames) {
            this.classNames = classNames;
        },

        /**
         * Use only the specified views for processing.
         * Applied globally no matter what class it is.
         *
         * @param {string[]} viewIds
         */
        setGlobalViewIdsToInclude: function(viewIds) {
            this.specificViewIds = new Set(viewIds);
        },

        /**
         * Exclude the specified views from processing.
         * Applied globally no matter what class it is.
         *
         * @param {string[]} viewIds
         */
        setGlobalViewIdsToExclude: function(viewIds) {
            this.ignoringViewIds = new Set(viewIds);
        },

        /**
         * Add class/viewId pair for further processing
         *
         * @param {String} className
         * @param {String} viewId
         */
        addClassViewPair: function(className, viewId) {
            var reflectionClass = reflection.getClass(className);
            if (!reflectionClass) {
                console.warn("Cannot find the reflection class with name=", className);
                return;
            }

            // add view to this class and all derived classes
            reflectionClass.traverse(false, true, function(cls) {
                var viewSet = this.classToViewIdMap.get(cls);
                if (!viewSet) {
                    viewSet = new Set();
                    this.classToViewIdMap.set(cls, viewSet);
                }
                viewSet.add(viewId);
            }, this);
        },

        /**
         * Get reflection classes for processing
         *
         * @return {reflection.Class[]}
         */
        getReflectionClasses: function() {
            var allClasses = null;

            if (this.classNames && this.classNames.length)
                allClasses = this.classNames.map(reflection.getClass);
            else
                allClasses = reflection.getClasses();

            // filter out classes not in classToViewIdMap
            if (this.classToViewIdMap.size > 0) {
                allClasses = allClasses.filter(function(cls) {
                    return this.classToViewIdMap.has(cls);
                }, this);
            }

            return allClasses;
        },

        /**
         * True if we need to process this view globally not matter what class it is.
         *
         * @param {String} viewId
         */
        shouldProcessView: function(viewId) {
            var useAllViews = this.specificViewIds == null || this.specificViewIds.size == 0;
            var inIgnoredViews = this.ignoringViewIds != null && this.ignoringViewIds.has(viewId);
            return (useAllViews || this.specificViewIds.has(viewId)) && !inIgnoredViews;
        },

        /**
         * True if we need to process this view for this particular class.
         *
         * @param {reflection.Class} rc
         * @param {String} viewId
         */
        shouldProcessViewForClass: function(rc, viewId) {
            if (this.classToViewIdMap.size == 0)
                return true;

            var viewSet = this.classToViewIdMap.get(rc);
            return viewSet && viewSet.has(viewId);
        }
    });
});